import { type Organization } from '@app/client/common/structs/organizations/organizations';

export const ACTION_SET_ORGANIZATIONS = 'ACTION_SET_ORGANIZATIONS';

export interface OrganizationsState {
    organizations: Organization[] | null;
}

interface SetOrganizationsAction {
    type: typeof ACTION_SET_ORGANIZATIONS;
    organizations: Organization[];
}

export type OrganizationsActionsTypes = SetOrganizationsAction;
